import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import rootReducer from "../App/reducers";

const initialState = {};
const middleware = [thunk];

// Since you want to delete the extension, we can simplify even further:
const store = createStore(
  rootReducer,
  initialState,
  applyMiddleware(...middleware)
);

export default store;
